if ($(window).width() < 600) {
    for(let i = 0; i < $('.img').length; i++) {
        if($($('.img')[i]).data('ismobile')){
            let src = $($('.img')[i]).attr('src').split('.')[0];
            let ext = $($('.img')[i]).attr('src').split('.')[1];
            $($('.img')[i]).attr('src', src + '-mobile.'+ ext);
        }
    }
}